export const getFormattedValue = (value) => {
    return value || value ===0? value: "NA";
 }
